import script from "./VehicleGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleGrid.vue?vue&type=script&setup=true&lang=js"

import "./VehicleGrid.vue?vue&type=style&index=0&id=38f51689&lang=css"

const __exports__ = script;

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/.pnpm/vue-cli-plugin-quasar@5.0.2/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QChip,QBtn});
